import React from "react";
import SectionHeadingBadge from "../../components/badges/SectionHeadingBadge";
import Discover from "../../assets/icons/globe.svg";
import Adapt from "../../assets/icons/adapt.svg";
import Build from "../../assets/icons/build.svg";
import Launch from "../../assets/icons/launch.svg";
import { Card } from "react-bootstrap";

function OurApproach() {
  const approachCards = [
    {
      step: "01",
      iconSrc: Discover,
      iconBg: "#00c0d4",
      label: "Discover & Analyze",
      title: "The Global Blueprint",
      description:
        "We begin by deeply analyzing successful global products and business models relevant to your industry. We identify the core mechanics, the value proposition, and the key drivers of their success.",
    },
    {
      step: "02",
      iconSrc: Adapt,
      iconBg: "#6b66da",
      label: "Adapt & Strategize",
      title: "The Local Strategy",
      description:
        "This is our core strength. We map the global blueprint to the local context. We conduct market research, validate concepts with local users, and build a product strategy that is culturally relevant and poised for adoption.",
    },
    {
      step: "03",
      iconSrc: Build,
      iconBg: "#ffa900",
      label: "Build & Engineer",
      title: "World-Class Engineering",
      description:
        "Our expert teams build your product using cutting-edge architectures and a future-focused tech stack. We specialize in leveraging deep technologies like AI, machine learning, and data science to create intelligent, efficient, and secure platforms.",
    },
    {
      step: "04",
      iconSrc: Launch,
      iconBg: "#f17216",
      label: "Launch & Scale",
      title: "Long-Term Partnership",
      description:
        "Our work doesn't end at launch. We are your long-term partners, helping you navigate the market, gather user feedback, and create a roadmap for future growth and feature enhancements.",
    },
  ];
  return (
    <div className="container d-flex flex-column justify-content-center vh-100 align-items-center gap-3 mb-3">
      <SectionHeadingBadge text="Our Approach" />
      <h1 className="text-white oswald-Bold font-48 text-transform-uppercase text-center">
        From Blueprint to Market Leader
      </h1>
      <p className="font-14 poppins-light color-theme-sub text-center">
        Visual Idea: A 4-step infographic with icons for each stage.
      </p>
      <div className="d-flex flex-wrap gap-3  justify-content-center">
        {approachCards.map((card, index) => (
          <Card
            key={`approach-card-${index}`}
            className="rounded border-none bg-dark px-3 py-4 w-45 cursor-pointer card-hover"
          >
            <div className="p-6">
              <div className="d-flex align-items-start gap-4">
                <div
                  className={`d-flex algin-items-center justify-content-center p-2 rounded `}
                  style={{ background: card.iconBg, width: "fit-content" }}
                >
                  <img
                    className="w-[38px] h-[38px]"
                    alt={`Step ${card.step} icon`}
                    src={card.iconSrc}
                  />
                </div>
                <div className="d-flex align-items-start gap-3">
                  <span className="poppins-light text-white text-base">
                    {card.step}
                  </span>

                  <div className="d-flex flex-column gap-2">
                    <div className="d-flex flex-column gap-3">
                      <div className="inline-flex align-items-center px-2 py-px bg-white rounded width-fit-content">
                        <span className="azeret-mono-light font-14 ">
                          {card.label}
                        </span>
                      </div>

                      <h3 className="poppins-semibold text-white text-base font-16">
                        {card.title}
                      </h3>
                    </div>

                    <p className="text-white text-white font-14 poppins-light">
                      {card.description}
                    </p>
                  </div>
                </div>
              </div>
            </div>
          </Card>
        ))}
      </div>
    </div>
  );
}

export default OurApproach;
